import React, { useContext } from "react";
import OurTeam from "../cards/team";
import Slider from "../common/Slider";
import { getSliderSettings } from "./recentJobGroup";
import { TeamContext } from "../../App";
import { Users } from "lucide-react";

function TeamGroup() {
  const ourTeam = useContext(TeamContext);

  if (!Array.isArray(ourTeam) || ourTeam.length === 0) {
    return null;
  }

  const settings = getSliderSettings({
    dots: false,
    arrows: true,
    slidesToShow: 3,
    removeAutoPlay: false,
    slidesToShowAt1024Breakpoint: 2,
    slidesToShowAt992Breakpoint: 1,
    objectCount: ourTeam.length,
    speed: 500,
    autoplaySpeed: 15000,
  });

  return (
    <section className="cht-py-14 sm:cht-py-20 cht-bg-white cht-border-y cht-border-slate-200/80 !cht-font-body">
      <div className="cht-max-w-7xl cht-mx-auto cht-px-4 sm:cht-px-6 lg:cht-px-8">
        <header className="cht-text-center cht-max-w-2xl cht-mx-auto cht-mb-12 sm:cht-mb-16">
          <div className="cht-inline-flex cht-items-center cht-gap-2 cht-px-3.5 cht-py-1.5 cht-bg-blue-50 cht-border cht-border-blue-100 cht-rounded-full cht-text-xs !cht-font-bold cht-text-[#3e57da] cht-mb-4">
            <Users size={14} />
            <span>Leadership & Core Team</span>
          </div>

          <h2 className="!cht-font-heading cht-text-2xl sm:cht-text-3xl md:cht-text-4xl !cht-font-extrabold cht-text-[#1e293b] cht-tracking-tight cht-mb-3">
            Meet Our Exceptional Team
          </h2>

          <p className="!cht-font-body cht-text-sm sm:cht-text-base cht-text-slate-600 cht-leading-relaxed">
            The passionate engineers, designers, and instructors driving innovation and excellence across Codehub Technologies.
          </p>
        </header>

        <div className="cht-px-2">
          <Slider {...settings}>
            {ourTeam.map((item) => (
              <OurTeam
                key={item.id}
                name={item.name}
                position={item.position}
                image={item.get_image_url}
                socialList={item.team_social}
              />
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
}

export default TeamGroup;

